import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isProfileIncomplete } from '../../utils/invoiceProfile';
import { useDriverFeeBlocked } from '../../hooks/useDriverFeeBlocked';
import { COLORS } from '../../styles/tokens';

// Gjenbrukt herfra for oppdragssperrene
export { isProfileIncomplete };

// Sant når sjåføren ikke kan ta eller by på oppdraget: manglende utbetaling og fakturering (alle oppdrag),
// eller forfalt Tippi-gebyr (feeBlocked) på fakturaoppdrag.
export function isInvoiceBlocked(order, userDoc, feeBlocked = false) {
  if (!order) return false;
  if (isProfileIncomplete(userDoc)) return true;
  return order.paymentMethod === 'invoice' && !!feeBlocked;
}

// Melding om sperre (forfalt gebyr / manglende utbetaling og fakturering) med lenke,
// eller forklaring på fakturaoppdrag når alt er på plass.
export default function InvoiceProfileHint({ order }) {
  const { userDoc } = useAuth();
  const { blocked: feeBlocked } = useDriverFeeBlocked();
  const isInvoice = order?.paymentMethod === 'invoice';
  if (userDoc?.carrierOrgId) {
    return (
      <div role="alert" style={{ ...styles.box, background: COLORS.warningBg, borderColor: COLORS.warningBorder, color: COLORS.warningText }}>
        <span style={styles.text}>Sjåfører i et transportfirma kan ikke ta markedsplass-oppdrag ennå.</span>
      </div>
    );
  }
  const profileMissing = isProfileIncomplete(userDoc);
  if (!isInvoice && !profileMissing) return null;

  if (isInvoice && feeBlocked) {
    return (
      <div role="alert" style={{ ...styles.box, background: COLORS.warningBg, borderColor: COLORS.warningBorder, color: COLORS.warningText }}>
        <span style={styles.text}>Du kan ikke ta fakturaoppdrag før Tippi-gebyret er betalt. Se Inntekt.</span>
        <Link to="/driver/earnings" style={styles.link} onClick={e => e.stopPropagation()}>Gå til Inntekt</Link>
      </div>
    );
  }

  if (profileMissing) {
    return (
      <div role="alert" style={{ ...styles.box, background: COLORS.warningBg, borderColor: COLORS.warningBorder, color: COLORS.warningText }}>
        <span style={styles.text}>Utbetaling og fakturering mangler.</span>
        <Link to="/driver/profil#faktura" style={styles.link} onClick={e => e.stopPropagation()}>Fyll ut</Link>
      </div>
    );
  }
  return (
    <div style={{ ...styles.box, background: COLORS.white, borderColor: COLORS.border, color: COLORS.textMid }}>
      Faktura: du fakturerer bestiller via Tippi etter levering, og får betalt direkte.
    </div>
  );
}

// Kompakt rad: tekst til venstre, liten lenke til høyre. Luft over og under så boksen aldri tetter mot naboene.
const styles = {
  box:  { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 10, border: '1px solid', borderRadius: 12, padding: '10px 12px', fontSize: 13, lineHeight: 1.4, margin: '12px 0' },
  text: { flex: '1 1 auto', minWidth: 0, overflowWrap: 'anywhere' },
  link: { flexShrink: 0, whiteSpace: 'nowrap', color: COLORS.textDark, fontWeight: 700, textDecoration: 'underline' },
};
